
import {
  defineComponent,
  computed,
  ref,
  onMounted,
} from 'vue';
import {
  useStore,
} from 'vuex';
import AnimateScroll from '@/utils/AnimateScroll';

export default defineComponent({
  props: {
    showBadge: {
      type: String,
      required: false,
      default: () => 'false',
    },
    paddingTop: {
      type: String,
      required: false,
      default: () => 'default',
    },
    paddingBottom: {
      type: String,
      required: false,
      default: () => 'default',
    },
    spacer: {
      type: String,
      required: false,
      default: () => 'none',
    },
    spacerCloudsPlacement: {
      type: String,
      required: false,
      default: () => 'bottom',
    },
    spacerBarAlign: {
      type: String,
      required: false,
      default: () => 'right',
    },
    klimaheldButton: {
      type: String,
      required: false,
      default: () => 'false',
    },
  },

  setup(props) {
    const store = useStore();
    const showCo2Badge = props.showBadge !== 'false';
    const showKlimaheldButton = computed<boolean>(() => props.klimaheldButton === 'true');
    const hasKlimaheldSection = computed(() => store.getters['pages/hasKlimaheldSection']);
    const badge = ref();
    const {
      ioappConfig: {
        themeUri,
      },
    } = window;
    const animateScroll = new AnimateScroll();

    const containerClasses = computed<string[]>(() => {
      const containerClassesComputed: string[] = [];

      if (props.paddingTop === 'none') {
        containerClassesComputed.push('pt-0');
      }

      if (props.paddingBottom === 'none') {
        containerClassesComputed.push('pb-0');
      }

      return containerClassesComputed;
    });

    onMounted(() => {
      if (showCo2Badge && badge.value) {
        badge.value.style.backgroundImage = `url('${themeUri}/assets/img/co2-badge.svg')`;
      }
    });

    const scrollToKlimaheld = () => {
      animateScroll.scrollVerticalToElementById('klimaheld-werden', 80);
    };

    return {
      showCo2Badge,
      containerClasses,
      badge,
      showKlimaheldButton,
      hasKlimaheldSection,
      scrollToKlimaheld,
    };
  },
});
